// Work around for https://github.com/firebase/firebase-js-sdk/issues/4110
// Don't do anything, lean on AngularFire's DI init
